import { lazy, Suspense, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { CartProvider } from './contexts/CartContext'
import { EditModeProvider } from './contexts/EditModeContext'
import CartDrawer from './components/CartDrawer'
import EditModeFAB from './components/EditModeFAB'
import Header from './components/Header'
import Footer from './components/Footer'
import TopBanner from './components/TopBanner'
import CookieBanner from './components/CookieBanner'
import Home from './pages/Home'

// Code-splitting par route : seule la page d'accueil (Home) est chargee
// immediatement afin de reduire le JS initial telecharge/execute (LCP/FID).
// Toutes les autres pages sont chargees a la demande via React.lazy.
const Gallery = lazy(() => import('./pages/Gallery'))
const Universe = lazy(() => import('./pages/Universe'))
const Artwork = lazy(() => import('./pages/Artwork'))
const About = lazy(() => import('./pages/About'))
const Contact = lazy(() => import('./pages/Contact'))
const AdminNew = lazy(() => import('./pages/AdminNew'))
const AdminUpdates = lazy(() => import('./pages/AdminUpdates'))
const Actualites = lazy(() => import('./pages/Actualites'))
const Press = lazy(() => import('./pages/Press'))
const Cart = lazy(() => import('./pages/Cart'))
const PaymentSuccess = lazy(() => import('./pages/PaymentSuccess'))
const InvitationRegister = lazy(() => import('./pages/InvitationRegister'))
const Retraites = lazy(() => import('./pages/Retraites'))

const HardRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.replace(to)
  }, [to])
  return null
}

const RouteFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center bg-[#FAF9F6]">
    <div className="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-[#722F37]" />
  </div>
)

function App() {
  return (
    <Router>
      <CartProvider>
        <EditModeProvider>
        <div className="min-h-screen bg-[#FAF9F6] text-[#2C2C2C] font-[Inter]">
          <TopBanner />
          <Header />
          <main>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/artwork/:id" element={<Artwork />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/actualites" element={<Actualites />} />
                <Route path="/events" element={<Navigate to="/actualites" replace />} />
                <Route path="/press" element={<Press />} />
                <Route path="/invitation/:eventId" element={<InvitationRegister />} />
                <Route path="/retraites" element={<Retraites />} />
                <Route path="/terms" element={<HardRedirect to="/terms.html" />} />
                <Route path="/privacy-policy" element={<HardRedirect to="/privacy-policy.html" />} />
                <Route path="/shipping" element={<HardRedirect to="/shipping.html" />} />
                <Route path="/legal-notice" element={<HardRedirect to="/legal-notice.html" />} />
                <Route path="/terms-of-use" element={<HardRedirect to="/terms-of-use.html" />} />
                <Route path="/returns" element={<HardRedirect to="/returns.html" />} />
                <Route path="/privacy" element={<HardRedirect to="/privacy-policy.html" />} />
                <Route path="/admin" element={<AdminNew />} />
                <Route path="/admin/evolutions" element={<AdminUpdates />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <CartDrawer />
          <EditModeFAB />
          <CookieBanner />
          <Toaster position="bottom-right" />
        </div>
        </EditModeProvider>
      </CartProvider>
    </Router>
  )
}

export default App
